var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{key:"normalbutton",staticClass:"btn",class:_vm.color},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }